function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Vrstva_1"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Vrstva_2"
}, React.createElement("g", null, React.createElement("path", {
  d: "M455,735H210c-5.523,0-10,4.478-10,10s4.477,10,10,10h245c5.523,0,10-4.478,10-10S460.523,735,455,735z"
}), React.createElement("path", {
  d: "M783,497h-90c-5.522,0-10,4.478-10,10s4.478,10,10,10h90c5.522,0,10-4.478,10-10S788.522,497,783,497z"
}), React.createElement("path", {
  d: "M477,497H210c-5.523,0-10,4.478-10,10s4.477,10,10,10h267c5.523,0,10-4.478,10-10S482.523,497,477,497z"
}), React.createElement("path", {
  d: "M768,279h15c5.522,0,10-4.477,10-10s-4.478-10-10-10h-15c-5.522,0-10,4.477-10,10S762.478,279,768,279z"
}), React.createElement("path", {
  d: "M210,279h348c5.522,0,10-4.477,10-10s-4.478-10-10-10H210c-5.523,0-10,4.477-10,10S204.477,279,210,279z"
}), React.createElement("path", {
  d: "M729.893,285.226c0.621-2.061,0.924-4.172,0.923-6.248c-0.002-4.673-1.512-9.13-4.185-12.783 c-2.665-3.653-6.568-6.537-11.217-7.933l-78.882-23.76c-2.061-0.621-4.172-0.923-6.246-0.923 c-4.674,0.002-9.13,1.512-12.784,4.185c-3.653,2.665-6.537,6.568-7.933,11.218L503.162,602.23 c-0.621,2.062-0.923,4.173-0.923,6.246c0.003,4.674,1.512,9.13,4.186,12.784c2.665,3.654,6.569,6.539,11.22,7.934l78.879,23.76 c2.06,0.621,4.172,0.924,6.247,0.923c4.674-0.002,9.13-1.512,12.783-4.186c3.653-2.664,6.537-6.567,7.933-11.216l-9.574-2.886 l9.575,2.884L729.893,285.226z M604.337,632.706L604.337,632.706c-0.122,0.388-0.309,0.627-0.596,0.847 c-0.287,0.211-0.643,0.326-0.971,0.324c-0.149,0-0.3-0.02-0.479-0.073l-78.881-23.76c-0.389-0.122-0.628-0.307-0.847-0.595 c-0.211-0.287-0.327-0.643-0.324-0.973c0-0.15,0.02-0.3,0.072-0.477L628.72,254.749v-0.001c0.121-0.386,0.307-0.625,0.594-0.845 c0.287-0.211,0.644-0.327,0.973-0.325c0.149,0,0.3,0.02,0.478,0.073l78.882,23.76c0.387,0.121,0.627,0.307,0.846,0.595 c0.211,0.287,0.326,0.643,0.324,0.971c0,0.149-0.02,0.3-0.073,0.479L604.337,632.706z"
}), React.createElement("path", {
  d: "M603.124,672.398l-101.242-30.496c-3.42-1.03-7.131-0.157-9.734,2.29s-3.702,6.097-2.884,9.575 l24.21,102.927c0.818,3.478,3.43,6.255,6.851,7.285c3.42,1.03,7.131,0.157,9.734-2.29l77.031-72.431 c2.604-2.447,3.703-6.097,2.885-9.575C609.156,676.206,606.545,673.429,603.124,672.398z M528.977,735.254l-16.278-69.206 l68.073,20.505L528.977,735.254z"
}), React.createElement("path", {
  d: "M678.234,294.758c-5.288-1.593-10.866,1.403-12.459,6.691l-86.005,285.516 c-1.593,5.289,1.402,10.867,6.69,12.46c5.289,1.593,10.867-1.403,12.46-6.691l86.005-285.516 C686.519,301.929,683.523,296.351,678.234,294.758z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/custom-zaznamy.6fecc0cb.svg";
export { SvgComponent as ReactComponent };